import { Link } from 'react-router-dom';

import { useCapability } from '../../../../hooks/use-capability';

/**
 * Sprint A4 S2 consolida config de IA (modelos por agente) na aba IA aqui.
 * Por ora, apenas redireciona pra `/admin/ai-config` (existente) — preserva
 * o caminho atual sem fragmentar UX.
 */
export function AiTab(): JSX.Element {
  const canAiConfig = useCapability('custom-model-selection');

  return (
    <div className="flex h-full flex-col items-center justify-center gap-4 p-12 text-center">
      <span className="text-4xl">🤖</span>
      <h2 className="text-lg font-semibold text-text-primary">Configurações de IA</h2>
      <p className="max-w-md text-sm text-text-secondary">
        A gestão de modelos de IA por agente (consolidação na Sprint A4 S2) ainda está em{' '}
        <strong>/admin/ai-config</strong>.
      </p>
      {canAiConfig ? (
        <Link
          to="/admin/ai-config"
          className="rounded bg-accent px-4 py-2 text-sm text-white hover:bg-accent-hover"
        >
          Ir para Configurações de IA →
        </Link>
      ) : (
        <span className="text-xs text-text-secondary">
          Capability <code>custom-model-selection</code> necessária (Professional+).
        </span>
      )}
    </div>
  );
}
